"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DropdownIndicator = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactSelect = require("react-select");

var _SvgInSelectArrow = require("../../../svg/interface/SvgInSelectArrow");

var ADropdownIndicator = _reactSelect.components.DropdownIndicator;

var DropdownIndicator = function DropdownIndicator(props) {
  // eslint-disable-next-line
  var isMulti = props.isMulti; // eslint-disable-next-line

  var value = props.getValue();
  return /*#__PURE__*/_react.default.createElement(ADropdownIndicator, props, isMulti ? /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: 'counter'
  }, "".concat(value.length)), /*#__PURE__*/_react.default.createElement("div", {
    className: 'indicator'
  }, /*#__PURE__*/_react.default.createElement(_SvgInSelectArrow.SvgInSelectArrow, null))) : /*#__PURE__*/_react.default.createElement(_SvgInSelectArrow.SvgInSelectArrow, null));
};

exports.DropdownIndicator = DropdownIndicator;